import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import IcecreamAccident from '@atlassian/jira-illustrations/src/ui/adg4/jira/heroes/components/icecream-accident';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { FireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages';

export type Props = Intl;

/**
 * An error empty state with a retry button for when there's a fetch failure on this report.
 */
export const ErrorEmptyState = ({ intl }: Props) => (
	<>
		<EmptyState
			renderImage={getAkEmptyStateRenderImageFn(IcecreamAccident)}
			header={intl.formatMessage(messages.fetchError)}
		/>

		<FireOperationalAnalytics eventName="velocityChart failed" />
	</>
);

const ErrorEmptyStateWithIntl = injectIntl(ErrorEmptyState);

export default ErrorEmptyStateWithIntl;
